import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isModalOpen: false,
};

const referralCodeSlice = createSlice({
    name: 'referralcode',
    initialState,
    reducers: {
        setVisibility(state, action) {
            state.isModalOpen = action.payload;
        },
        
        clear: (state) => initialState,
        logout: (state) => initialState,
    },
});

export const referralCodeActions = referralCodeSlice.actions;
export default referralCodeSlice;
